import { reatomAsync } from "@reatom/async";
import { API } from "src/api.ts";
import { withIsLoadingAtom } from "src/common/pipes";

import { listWatermarksRequest } from "./listWatermarksRequest";

export const uploadWatermarkRequest = reatomAsync(
  async (
    ctx,
    {
      file,
      onProgress,
    }: {
      file: File;
      onProgress?: (percent: number) => void;
    },
  ) => {
    const response =
      await API.objectStorageApi.objectStorageControllerUploadWatermark(file, {
        signal: ctx.controller.signal,
        onUploadProgress: (event) => {
          if (!event.total || !onProgress) return;
          onProgress(Math.round((event.loaded * 100) / event.total));
        },
        transformRequest: (data, headers) => {
          delete headers["Content-Type"];
          return data;
        },
      });
    return response.data;
  },
  {
    name: "uploadWatermarkRequest",
    onFulfill: (ctx) => listWatermarksRequest(ctx),
  },
).pipe(withIsLoadingAtom());
